import renderSearch from "./renderSearch.jsx";
// This is required to make Storybook run JS when patterns are choosen
import { getJSON } from "./common/helpers.js";
const selectors = document.querySelectorAll(".js-search-mount");

selectors.forEach((mount, i) => {
  const domJSON = getJSON([mount]);
  mount.setAttribute("data-dom", JSON.stringify(domJSON));
});

document.addEventListener("DOMContentLoaded", () => {
  renderSearch();
  document?.querySelector(".search-app")?.classList?.remove("is-loading");

});
